import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createAction } from "../../services/action";
import { toast } from "react-toastify";
import { IIndicators } from "../../types";

const useCreateAction = (indicators: IIndicators) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createAction,

    onMutate: () => {
      indicators.setIsProcessRunning(true);
    },

    onSuccess: (status) => {
      if (status === 200) {
        queryClient.invalidateQueries({ queryKey: ["notification-actions"] });
        indicators.setIsProcessRunning(false);
        toast.success("Action created successfully!");
      }
    },

    onError: (error: any) => {
      indicators.setIsProcessRunning(false);
      toast.error(error.response?.data?.message);
      indicators.setIsServiceError(error.response?.data?.message);
    },
  });
};

export default useCreateAction;
